import { SxProps } from '@mui/material';

export const ModalLoginFrameSx: SxProps = {
	position: 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	width: '80vw',
	maxWidth: '661px',
	bgcolor: 'background.paper',
	boxShadow: 24,
	padding: '0px',
};

export const ModalLoginHeaderIconCloseFrameSx: SxProps = {
	margin: '0px',
	'&:hover': {
		backgroundColor: 'transparent',
		color: 'inherit',
	},
};

export const ModalLoginHeaderIconCloseSx: SxProps = {
	fontSize: 'var(--font-size-xl)',
};

export const ModalLoginTitleSx: SxProps = {
	fontSize: 'var(--font-size-xl)',
	fontWeight: 800,
	textAlign: 'center',
	marginBottom: '30px',
};

export const ModalLoginContentSx: SxProps = {
	display: 'grid',
	gap: '50px',
	gridTemplateColumns: '1fr 3px 1fr',
	padding: '0px 40px 20px 40px',
};

export const ModalLoginRegisterContentSx: SxProps = {
	display: 'flex',
	flexDirection: 'column',
	justifyContent: 'space-between',
	gap: '20px',
};

export const ModalLoginRegisterTitleSx: SxProps = {
	fontSize: 'var(--font-size-md)',
	fontWeight: '800',
	letterSpacing: '0px',
	color: '#2C2C2C',
	textTransform: 'uppercase',
	opacity: 1,
};

export const ModalLoginRegisterTextSx: SxProps = {
	fontSize: 'var(--font-size-body)',
	textAlign: 'left',
};
